<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-2"><router-link  to="/">{{$t('property.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="almarai-bold mx-2">
          <router-link to="/propertie">
            {{$t('property.breadcrumb_2')}}
          </router-link>
        </li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li v-if="propertyType == 'rented'" class="active almarai-bold mx-3" aria-current="page">{{$t('property.Landlord')}}</li>
        <li v-else class="active almarai-bold mx-2" aria-current="page">{{$t('property.vacancy')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="text-center" v-if="isLoading">
          <mainloader />
        </div>
        <div v-else class="row">
          <div class="col">
            <!-- begin: rented Properties -->
            <div class="row pt-3" v-if="propertyType == 'rented' && rentedProperties">
              <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val,index) in rentedProperties" :key="index">
                <router-link :to="'/propertydetails/'+val.id+'?m=1&a=1'">
                  <div class="card card-border m-auto">
                    <div class="card-body padding-8">
                      <div class="row position-Abso pt-2">
                        <div class="col-auto tag-style">
                          <span class="">{{val.PropertyType.name }}</span>
                        </div>
                        <div class="col-auto tag-style mx-2">
                          <span class="">{{statusChoices[val.status] }}</span>
                        </div>
                      </div>
                      <swiper v-if="val.mediaFiles && val.mediaFiles.length" class="text-center" 
                        :modules="modules"
                        :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                        :pagination="{ clickable: true }" :navigation="false"
                      >
                        <swiper-slide v-for="(slide, indx) in val.mediaFiles" :key="indx">
                          <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                        </swiper-slide>
                      </swiper>
                      <div v-else>
                        <!-- <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt=""> -->
                        <placeHolder />
                      </div>
                      <div class="text-title py-1">{{ val.title }}</div>
                      <div class="d-flex">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                        <span class="gray-color fonttext-14 mx-2"> {{ val.Neighborhood.name }} </span>
                        <div class="gray-color fonttext-14 "> {{ val.City.name }} </div>
                      </div>
                      <hr class="border-color-w">

                      <div class="row space">
                        <div class="col-7 col-lg-7 button-center">
                          <div class="row">
                            <div class="col-auto ps-2 content-center">
                              <img src="/assets/images/icons/Frame-5.png" class="max-35" alt="">
                            </div>
                            <div class="col-4 col-md-6 p-0">
                              <div class="fontGray-73">{{$t('property.rentalValue')}}</div>
                              <span class="gray-color-60 mx-2">
                                {{ Number(val.collectedAmount).toLocaleString('en-US') }}
                              </span>
                              <img src="/assets/images/icons/riyal.png" class="max-12" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="col-5 col-lg-5">
                          <router-link :to="'/propertydetails/'+val.id+'?m=1'">
                            <div class="moreKnow-btn">{{$t('myproperty.more')}}</div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- end: rented Properties -->

            <!-- begin: availableProperties -->
            <div class="row pt-3" v-if="propertyType == 'availableProperties' && availableProperties">
              <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(valu,indx) in availableProperties" :key="indx">
                <router-link :to="'/propertydetails/'+valu.id+'?m=1'">
                  <div class="card card-border m-auto">
                    <div class="card-body padding-8">
                      <div class="row position-Abso pt-2">
                        <div class="col-auto tag-style">
                          <span class="">{{valu.PropertyType.name }}</span>
                        </div>
                        <div class="col-auto tag-style mx-2">
                          <span class="">{{statusChoices[valu.status] }}</span>
                        </div>
                      </div>
                      <swiper v-if="valu.mediaFiles && valu.mediaFiles.length" class="text-center" 
                        :modules="modules"
                        :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                        :pagination="{ clickable: true }" :navigation="false"
                      >
                        <swiper-slide v-for="(slide, indx) in valu.mediaFiles" :key="indx">
                          <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                        </swiper-slide>
                      </swiper>
                      <div v-else>
                        <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                      </div>
                      <div class="text-title py-1">{{ valu.title }}</div>
                      <div class="d-flex">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                        <span class="gray-color fonttext-14 mx-2"> {{ valu.Neighborhood.name }} </span>
                        <div class="gray-color fonttext-14 "> {{ valu.City.name }} </div>
                      </div>
                      <hr class="border-color-w">

                      <div class="row space">
                        <div class="col-7 col-lg-7 button-center">
                          <div class="row">
                            <div class="col-auto ps-2 content-center">
                              <img src="/assets/images/icons/Frame-5.png" class="max-35" alt="">
                            </div>
                            <div class="col-4 col-md-6 p-0">
                              <div class="fontGray-73">{{$t('property.rentalValue')}}</div>
                              <span class="gray-color-60 mx-2">
                                {{ Number(valu.collectedAmount).toLocaleString('en-US') }}
                              </span>
                              <img src="/assets/images/icons/riyal.png" class="max-12" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="col-5 col-lg-5">
                          <router-link :to="'/propertydetails/'+valu.id+'?m=1'">
                            <div class="moreKnow-btn">{{$t('myproperty.more')}}</div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- end: availableProperties -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
export default {
  name: "ownerProperties",
  setup(){
    return{
      modules: [Autoplay, Navigation, Pagination ],
    }
  },
  data(){
    return {
      propertyType: this.$route.query.propertyType,
      hasError: false,
      message: "",
      isLoading: false,
      errorNumber: null,
      rentedProperties:[],
      icons: {},
      items: {},
      userLang: 'ar',
      containers: [],
      rentedProperties: [],
      soldProperties: [],
      availableProperties: [],
      totalRentalValue: null,
      totalCollectedAmount: null,
      statusChoices: {},
    }
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER'])
  },
  methods: {
    getStatics(){
      this.isLoading = true;
      this.$http.get('/api/properties/statics').then(res => {
        this.rentedProperties = res.data.rentedProperties;
        this.soldProperties = res.data.soldProperties;
        this.availableProperties = res.data.availableProperties;
        this.totalRentalValue = res.data.totalRentalValue;
        this.totalCollectedAmount = res.data.totalCollectedAmount;
        this.totalDueAmount = res.data.totalDueAmount;
        this.totalRemainingAmount = res.data.totalRemainingAmount;
        this.statusChoices = res.data.statusChoices;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },
  },
  created(){
    this.getStatics();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top : 'behavior'});
  },
}
</script>